module.exports = __webpack_public_path__ + "static/media/BOSCHLTD_F1.0ad52ecf.txt";